import React, { useEffect, useState } from 'react';
import './DashboardComp.css';

const DashboardComp = () => {
  const [reservations, setReservations] = useState([]);
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    // Simulating fetched data
    const fetchedReservations = [
      { id: 1, date: '2024-11-10', time: '2:00 PM', service: 'Haircut' },
      { id: 2, date: '2024-11-15', time: '1:00 PM', service: 'Shave' }
    ];
    setReservations(fetchedReservations);

    const fetchedOrders = [
      { id: 1, product: 'Beard Oil', price: 14.99, quantity: 2 },
      { id: 2, product: 'Hair Clipper', price: 99.99, quantity: 1 }
    ];
    setOrders(fetchedOrders);
  }, []);

  // Handler to remove a reservation by ID
  const removeReservation = (id) => {
    setReservations((prevReservations) => 
      prevReservations.filter((reservation) => reservation.id !== id)
    );
  };

  return (
    <div className="dashboard">
      <h1>Dashboard</h1>

      {/* My Reservations Section */}
      <div className="dashboard-section">
        <h2>My Reservations</h2>
        {reservations.length > 0 ? (
          <ul>
            {reservations.map((reservation) => (
              <li key={reservation.id}>
                <p>Date: {reservation.date}</p>
                <p>Time: {reservation.time}</p>
                <p>Service: {reservation.service}</p>
                <button onClick={() => removeReservation(reservation.id)}>Remove</button>
              </li>
            ))}
          </ul>
        ) : (
          <p>You have no reservations.</p>
        )}
      </div>

      {/* My Orders Section */}
      <div className="dashboard-section">
        <h2>My Orders</h2>
        {orders.length > 0 ? (
          <ul>
            {orders.map((order) => (
              <li key={order.id}>
                <p>Product: {order.product}</p>
                <p>Quantity: {order.quantity}</p>
                <p>Total Price: ${(order.price * order.quantity).toFixed(2)}</p>
              </li>
            ))}
          </ul>
        ) : (
          <p>You have no orders.</p>
        )}
      </div>
    </div>
  );
};

export default DashboardComp;
